import { normalizeRoutePlannerHeader } from '@/utils/routesRoutePlannerCsv';

/**
 * Maps API error message to normalized column key when errorField is absent.
 */
export function inferRoutesImportErrorField(message) {
  const m = String(message || '');
  if (/ambiguous vehicle/i.test(m) || /vehicle not found/i.test(m)) {
    return 'vehicle';
  }
  if (/ambiguous trailer/i.test(m) || /trailer not found/i.test(m)) {
    return 'trailer';
  }
  if (/ambiguous driver/i.test(m) || /driver not found/i.test(m)) {
    return 'driver';
  }
  if (/Missing departure or start/i.test(m)) {
    return 'departure';
  }
  if (/Missing start/i.test(m)) {
    return 'start';
  }
  if (/Invalid departure date\/time/i.test(m) || /Missing departure/i.test(m)) {
    return 'departure';
  }
  if (
    /Missing route name/i.test(m) ||
    /Duplicate route name in this file/i.test(m) ||
    /Route name already exists/i.test(m)
  ) {
    return 'route name';
  }
  if (
    /Stop coordinates must include both lat and lon/i.test(m) ||
    /Could not geocode stop:/i.test(m) ||
    /Need at least start and one location/i.test(m) ||
    /Stop is empty/i.test(m) ||
    /HERE: no compliant route found/i.test(m)
  ) {
    return 'start';
  }
  if (/Missing schedule dates or times/i.test(m)) {
    return 'departure';
  }
  return undefined;
}

export function resolveRoutesImportErrorField(apiResult, clientMissingFields) {
  if (apiResult?.errorField) {
    return apiResult.errorField;
  }
  if (clientMissingFields?.length) {
    return clientMissingFields[0];
  }
  return inferRoutesImportErrorField(apiResult?.message);
}

/** Whether a CSV header cell should highlight for this error field. */
export function headerMatchesErrorField(header, errorField) {
  if (!errorField || !header) {
    return false;
  }
  return normalizeRoutePlannerHeader(header) === errorField;
}

export function cellValueForHeader(normalizedRow, header) {
  const key = normalizeRoutePlannerHeader(header);
  const val = normalizedRow?.[key];
  if (val == null) {
    return '';
  }
  return String(val);
}
